import { render, staticRenderFns } from "./header_detail.vue?vue&type=template&id=8ded6618&"
import script from "./header_detail.vue?vue&type=script&lang=js&"
export * from "./header_detail.vue?vue&type=script&lang=js&"
import style0 from "./header_detail.vue?vue&type=style&index=0&id=8ded6618&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports